import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { UserAvatarMenu } from '@/components/shared/UserAvatarMenu';
import { ROUTES } from '@/configs/routes';
import { sessionStore } from '@/stores/global/RootStore';
import { useDevices } from '@/utils/devices';

import s from './Header.module.scss';

const Header: React.FC = () => {
  const { avatarLetter, isAuthenticated, logout } = sessionStore;
  const { pathname } = useLocation();
  const { isCompactViewport } = useDevices();

  const isOrganizationRoute = React.useMemo(
    () => Boolean(matchPath({ path: ROUTES.organization.path, end: false }, pathname)),
    [pathname],
  );

  if (!isAuthenticated) {
    return null;
  }

  // Скрываем Header на страницах организации в мобильной версии
  if (isCompactViewport && isOrganizationRoute) {
    return null;
  }

  return (
    <div className={s.root}>
      <UserAvatarMenu
        avatarLetter={avatarLetter}
        onLogout={logout}
        avatarClassName={s.root__avatar}
        dropdownClassName={s.root__dropdown}
      />
    </div>
  );
};

export default observer(Header);
